export const TextStar: React.FC = () => <span className="font-xs text-star">★</span>;
